import Notify from 'notifyjs';

export default function askPermissionNotification() {
  // quando o usuario deu permissão "permitir"
  function onPermissionGranted() {
    console.log('Permission has been granted by the user');
  }

  // quando o usuario de permissão "negada"
  function onPermissionDenied() {
    console.warn('Permission has been denied by the user');
  }

  // Verifica se o usuário deu permissão para notificar
  function onNotifyShow() {
    if (!Notify.needsPermission) {
      // doNotification();
    } else if (Notify.isSupported()) {
      Notify.requestPermission(onPermissionGranted, onPermissionDenied);
    }
  }

  // Inicia chamada notificação
  function initNotification() {
    onNotifyShow();
  }

  return initNotification();
}
